module.exports = __webpack_public_path__ + "static/media/icon_video_pause_transparent.859acb48.svg";